export default "https://cdn-static.gokick.com/assets/46c46890c219de5164704b27b734f3ae915944d1/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";